export const toggleOrTextMeBtn = (abOnlyTxtCta) => {
  let textInputModal = $('#textInputModal');
  let orTextMeButton = $('#srp-lead-modal').find('.or-text-me-button');
  if(Boolean(abOnlyTxtCta)) {
    textInputModal.modal('hide');
    orTextMeButton.removeClass("hidden");
    if ($('#qv-sticky-text-cta').hasClass("texted")) {
      orTextMeButton.text("Texted").addClass("texted");
    }
  } else {
    orTextMeButton.addClass("hidden");
  }
}

export const toggleOrEmailMeBtn = (target, abOnlyTxtCtaTextMe, abLeadSubmitted) => {
  let emailMeButton = $(target).find('.or-email-me-button');
  if (Boolean(abOnlyTxtCtaTextMe)) {
    emailMeButton.removeClass("hidden");
    if (abLeadSubmitted && abLeadSubmitted.value === "yes") {
      emailMeButton.text('Contacted').removeClass('js-qv-contact-agent').addClass('contacted');
    }
  } else {
    emailMeButton.addClass("hidden");
  }
}

export const showOnlyTextCta = () => {
  $('.qv-footer-email-text-btn').addClass("hidden");
  $('.qv-footer-question-btn').removeClass("hidden");
}

export const hideTextCta = () => {
  $('.qv-footer-email-text-btn').removeClass("hidden");
  $('.qv-footer-question-btn').addClass("hidden");
}


// WEBPACK FOOTER //
// ./quick_view/optimization/ab-only-text-cta-lead.js